
import { GlutenFreeFooterDrawer as NewDrawer } from "@/stable/ui-only-components/GlutenFreeFooterDrawer";
import { GlutenFreeFooterDrawer as OriginalDrawer } from "@/stable/ui-only-components-a/GlutenFreeFooterDrawer";
import { TestimonialQuizFlow } from "@/stable/ui-only-components/TestimonialQuizFlow";
import { OriginalFixedGlutenFreeFooter } from "@/components/organism/OriginalFixedGlutenFreeFooter";

const UrlVariationComponentMap = {
    a: OriginalDrawer,
    flow_a: OriginalDrawer,
    b: NewDrawer,
    flow_b: NewDrawer,
    d: TestimonialQuizFlow,
    c: OriginalFixedGlutenFreeFooter,
    flow_c: OriginalFixedGlutenFreeFooter,
    flow_d: TestimonialQuizFlow,
    testimonial: TestimonialQuizFlow,
    'testimonial-no-trial': TestimonialQuizFlow,
    'testimonial-trial': TestimonialQuizFlow,
    testimonial_flow2_e: TestimonialQuizFlow,
    flow2_e: NewDrawer,
    flow2_emailAtEnd: NewDrawer,
    flow2_f: NewDrawer,
    flow2_e2: NewDrawer,
    tt_april_testimonial: NewDrawer,
}

export const DrawerComponent = (props) => {
    const Component = UrlVariationComponentMap[props.quizVariation];

    if (!Component) {
        throw new Error(`Component for ${props.quizVariation} not found`);
    }

    return <Component {...props} />;
}